var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6581 56.5007C14.6661 57.5087 16.0048 58.0633 17.4288 58.0633C18.8528 58.0633 20.1915 57.5087 21.1995 56.5007L32.7621 44.938C34.6715 45.5273 36.6528 45.826 38.6741 45.826C44.0155 45.826 49.0395 43.7487 52.8128 39.9727C58.5355 34.2473 60.2448 25.7087 57.1648 18.218L55.6448 14.5167L44.3275 25.8313L38.6715 20.1727L49.9861 8.85798L46.2821 7.33532C43.8555 6.33798 41.2928 5.83398 38.6635 5.83398C33.3221 5.83398 28.3008 7.91398 24.5275 11.69C19.2341 16.9807 17.3755 24.682 19.5621 31.738L7.99945 43.3007C5.91945 45.378 5.91945 48.7647 7.99945 50.842L13.6581 56.5007ZM25.7861 33.058L25.1088 31.4153C22.8475 25.9193 24.1008 19.6553 28.2981 15.4607C31.0661 12.6927 34.7461 11.1673 38.6635 11.1673C39.1355 11.1673 39.6021 11.1887 40.0661 11.234L31.1248 20.1753L44.3221 33.3753L53.2688 24.4286C53.6848 28.7167 52.1941 33.0447 49.0368 36.2047C44.9035 40.338 38.4661 41.61 33.0795 39.394L31.4395 38.714L17.4288 52.73H17.4315L17.4288 55.3967V52.73L11.7701 47.0713L25.7861 33.058Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxWrench);
export default __webpack_public_path__ + "static/media/bx-wrench.be96a01e69609cc216952b6e8aa58315.svg";
export { ForwardRef as ReactComponent };